// src/config/images.js

const images = {
    // Background images used across multiple pages
    backgrounds: {
      main: "https://thumbs.cityrealty.com/assets/fit-in/2000x1500/webp/9/95/9528726c9f05857754ece1ea6654e91eb3ee7f3b/the-clinton-lofts-148-clinton-street.jpg",
      secondary: "https://images.unsplash.com/photo-1709287229313-f3b967d49437?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      tertiary: "https://thumbs.cityrealty.com/assets/fit-in/1400x932/webp/9/9a/9af2ec2adb29aee9bb462323ae848bb3a6785e5c",
    },
    
    // Hero section backgrounds
    hero: {
      home: "https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?q=80&w=3087&auto=format&fit=crop",
      contact: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=3087&auto=format&fit=crop",
      portfolio: "https://images..com/photo-1600585154340-be6161a56a0c?q=80&w=3087&auto=format&fit=crop",
      details: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=3087&auto=format&fit=crop",
    },
    
    // Service images 
    services: {
      customHome: "http://tiny.cc/9moh001",
      renovation: "http://tiny.cc/rmoh001",
      commercial: "http://tiny.cc/nmoh001",
    },
    
    // Portfolio project images
    portfolio: {
      project1: [
        "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/148-150_Clinton_-kitchen02-2-scaled.jpg",
        "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1600&q=80",
        "https://images.unsplash.com/photo-1600566753151-384129cf4e3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1600&q=80"
      ],
      project2: [
        "https://images.unsplash.com/photo-1600585154526-990dced4db0d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1600&q=80",
        "https://images.unsplash.com/photo-1600573472550-8090733a21e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1600&q=80",
        "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1600&q=80"
      ]
    }
  };
  
  export default images;